export function condBase(c, conds, baseU, depth) {
  if (!c || (depth || 0) > 8) return 0;
  const par = c.par || baseU;
  const q = parseFloat(('' + c.qte).replace(',', '.')) || 0;
  if (!par || par === baseU) return q;
  const parent = (conds || []).find((x) => x.nom === par);
  return parent ? q * condBase(parent, conds, baseU, (depth || 0) + 1) : q;
}

export const UNITS_LIST = [
  { v: 'm²', l: 'm² · mètre carré' },
  { v: 'm', l: 'm · mètre' },
  { v: 'ml', l: 'ml · mètre linéaire' },
  { v: 'm³', l: 'm³ · mètre cube' },
  { v: 'pce', l: 'pce · pièce' },
  { v: 'forfait', l: 'forfait' },
  { v: 'h', l: 'h · heure' },
  { v: 'j', l: 'j · jour' },
  { v: 'kg', l: 'kg · kilo' },
  { v: 'l', l: 'l · litre' },
  { v: 't', l: 't · tonne' },
  { v: 'u', l: 'u · unité' },
];

export const COND_TYPES = ['Rouleau', 'Carton', 'Palette', 'Barre', 'Bidon', 'Boîte', 'Sac', 'Lot'];
